import React from 'react';
import { Navigation } from './components';
import { Link } from 'react-router-dom';
import { Minicart } from 'components/Minicart';

const Header = () => (
    <header className="header">
        <div className="header__wrapper">
            <Navigation />
            <Link className="logo" to="/">
                <img src="/images/logo.svg" alt="Luthien Logo" />
            </Link>
            <Minicart />
        </div>
    </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx